import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import i18n from '@i18n';
import EditorWithComments from '@/betbook/views/EditorWithComments';
import { clearPostDetail, fetchPostById, incrementBetbookPostViewCount } from '@/betbook/handlers';
import { postDetail$ } from '@/betbook/subs';
import { incrementPostViews } from 'nike-ui/src/components/betbook/handlers';
import BetbookAnalysisItem from '@/betbook/views/BetbookAnalysisItem';
import { POST_ANALYSIS } from 'nike-ui/src/components/betbook/constants';
import { BetbookContextProvider } from 'nike-ui/src/common/BetbookContext';

function BetbookAnalysisDetail({ postId }) {
    const { subscribe } = useReframe();
    const post = subscribe(postDetail$);
    const commentsCount = post?.commentCount || 0;

    useEffect(() => {
        dispatch(fetchPostById(POST_ANALYSIS, postId));
        incrementPostViews(POST_ANALYSIS, postId, id => dispatch(incrementBetbookPostViewCount(id)));
        return () => dispatch(clearPostDetail);
    }, [postId]);

    if (!post) {
        return null;
    }
    if (post.error === 'NOT_FOUND') {
        return <EmptyState text={i18n('betbook.detail.notfound')} />;
    }

    return (
        <BetbookContextProvider
            betbookPostId={Number(postId)}
            betbookPostType={POST_ANALYSIS}
            betbookPostAuthor={post.author?.contractId}
            betbookBetId={post.pick?.betId}
            betbookBetSelectionCode={post.pick?.betSelectionCode}
        >
            <div className="betbook-post-wrapper-margin">
                <div className="betbook-post-wrapper">
                    <BetbookAnalysisItem post={post} detail />
                    <EditorWithComments commentsCount={commentsCount} subjectType={POST_ANALYSIS} subjectId={postId} />
                </div>
            </div>
        </BetbookContextProvider>
    );
}

export default BetbookAnalysisDetail;
